import { getRuntimeConfig } from "~/config/runtime.config";

/**
 * Redirect to the login page
 */
function login() {
  const apiUrl = getRuntimeConfig().LXC_AS_DEVICE_URL;
  window.location.href = `${apiUrl}/login?redirectUri=${encodeURIComponent(window.location.href)}&frontendBaseUrl=${encodeURIComponent(apiUrl || "")}`;
}

/**
 * Redirect to the logout page
 */
function logout() {
  window.location.href = `${getRuntimeConfig().LXC_AS_DEVICE_URL}/logout`;
}

export { login, logout };
